import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-NP19HWXDT5'; // remplace par ton ID

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
